export const TypedEvent = <D = any>(name: string, detail: D):
    CustomEvent<D> => new CustomEvent(name, { detail: detail })

// export interface TypedEvent {
//     <K extends keyof TypedEventHandlerMap>(name: K, detail: TypedEventHandlerMap[K]): CustomEvent<TypedEventHandlerMap[K]>
// }

// export interface TypedEventHandlerMap { }

export interface Disposable {
    dispose(): void
}

export interface TypedEventListener<E> { (evt: E): void };

// export interface EventEmitter {
//     on(handler: EventListener): Disposable
//     off(handler: EventListener): void
//     once(handler: EventListener): void
//     emit(event: Event): void
// }

export class TypedEventEmitter<E extends Event = Event> /*implements EventEmitter*/ {

    private readonly listeners: Array<TypedEventListener<E>>
    private listenersOnce: Array<TypedEventListener<E>> = [];

    constructor(listeners: Array<TypedEventListener<E>> = []) {
        this.listeners = listeners
    }

    // Add handler
    on(handler: TypedEventListener<E>): Disposable {
        this.listeners.push(handler);
        return {
            dispose: () => this.off(handler)
        };
    }

    // Remove handler
    off(handler: TypedEventListener<E>): void {
        const listenerIndex = this.listeners.indexOf(handler);
        if (listenerIndex > -1) {
            this.listeners.splice(listenerIndex, 1);
        }
    }

    // Execute one time and remove handler after
    once(handler: TypedEventListener<E>): void {
        // NAO FUNCIONA
        this.listenersOnce.push(handler);
    }

    // Raise event
    emit(event: E): boolean {
        this.listeners.forEach(listener => listener(event));
        this.listenersOnce.forEach(listener => listener(event));
        this.listenersOnce = [];
        return event.returnValue
    }

    // Add piped events
    pipe(emitter: TypedEventEmitter<E>): Disposable {
        return this.on((e: any) => emitter.emit(e));
    }
}

// interface EventListener<TEvent extends EventData = EventData> { (event: TEvent): void }



